import { RootState } from '@reducers';

export const selectDocumentDetails = (state: RootState) => state.userDashboardRouteReducer.documentDetails;
